import {Text} from 'platform/foundation';
import {css} from 'styled-components';

import {HTMLAttributeAnchorTarget} from 'react';

import {suffixTestId, TestIdProps} from 'shared/web';

export interface LinkProps extends TestIdProps {
  href: string;
  title: string;
  size?: 'base' | 'small' | 'xSmall';
  target?: HTMLAttributeAnchorTarget;
  download?: string | boolean;
  rel?: string;
}

export function Link(props: LinkProps) {
  return (
    <a
      rel={props.rel}
      target={props.target}
      download={props.download}
      href={props.href}
      css={css`
        color: ${({theme}) => theme.colors.text.link};
        display: inline-block;
        cursor: pointer;
        text-decoration: none;

        &:focus {
          box-shadow: none;
        }

        &:hover {
          text-decoration: underline;
        }
      `}
      data-testid={suffixTestId('link', props)}
    >
      <Text color="link" size={props.size} data-testid={suffixTestId('linkContent', props)}>
        {props.title}
      </Text>
    </a>
  );
}
